import styled from "styled-components";

const topBarHeight = 130;
const fixedTopBarHeight = 60;
const navbarHeight = 85;

export const FixedTopBarWrapper = styled.div`
  position: fixed;
  top: ${navbarHeight}px;
  left: 0;
  right: 0;
  height: ${fixedTopBarHeight}px;
  z-index: 1000;
`;

export const SidebarWrapper = styled.aside`
  position: fixed;
  top: ${navbarHeight + fixedTopBarHeight}px;
  left: 0;
  width: 280px;
  height: calc(100vh - ${navbarHeight}px - ${fixedTopBarHeight}px);
  background-color: var(--primary-dark-50);
  padding: 24px;
  z-index: 10;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const TopBarWrapper = styled.header`
  position: fixed;
  top: ${navbarHeight + fixedTopBarHeight}px;
  left: 280px;
  right: 15px;
  height: ${topBarHeight}px;
  padding: 24px;
  background-color: var(--primary-dark-50);
  z-index: 9;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    left: 0;
    right: 0;
    padding: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const MediaGridWrapper = styled.main`
  background-color: var(--primary-dark-50);
  margin-left: 280px;
  padding-top: calc(${topBarHeight}px + 70px);
  padding-right: 24px;
  padding-bottom: 24px;
  padding-left: 24px;
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;

  @media screen and (max-width: 1024px) {
    margin-left: 0;
  }

  @media screen and (min-width: 2500px) {
    display: flex;
    justify-content: flex-start;
    > div {
      max-width: 1920px;
    }
  }
`;
